import { v4 as uuid } from "uuid";

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
    {
        _id: uuid(),
        img: `${require("../../assets/images/shoe1.jfif")}`,
        title: "Nike",
        details: "Nike Air Force 1 '07 LV8'",
        rating: 4,
        price: 8295,
        gender: "men",
    },

    {
        _id: uuid(),
        img: `${require("../../assets/images/vans1.webp")}`,
        title: "Vans",
        details: "Vans Old Skool",
        rating: 3,
        price: 9695,
        gender: "men",
    },
    {
        _id: uuid(),
        img: `${require("../../assets/images/shoe2.jfif")}`,
        title: "Nike",
        details: "Nike Dunk High Retro SE",
        rating: 2,
        price: 10295,
        gender: "men",
    },
    {
        _id: uuid(),
        img: `${require("../../assets/images/vans2.webp")}`,
        title: "Vans",
        details: "Vans Sk8-Hi",
        rating: 3,
        price: 9695,
        gender: "men",
    },
    {
        _id: uuid(),
        img: `${require("../../assets/images/shoe3.jfif")}`,
        title: "Nike",
        details: "Nike Air Force 1 '07 LV8'",
        rating: 4,
        price: 9695,
        gender: "women",
    },
    {
        _id: uuid(),
        img: `${require("../../assets/images/vans3.webp")}`,
        title: "Vans",
        details: "Vans Old Skool Original",
        rating: 5,
        price: 9695,
        gender: "men",
    },

    {
        _id: uuid(),
        img: `${require("../../assets/images/nike2.webp")}`,
        title: "Nike",
        details: "Nike Air Force 1 '07",
        rating: 3,
        price: 10995,
        gender: "women",
    },
    {
        _id: uuid(),
        img: `${require("../../assets/images/nike3.webp")}`,
        title: "Nike",
        details: "Nike Air Presto",
        rating: 3,
        price: 11895,
        gender: "women",
    },
    {
        _id: uuid(),
        img: `${require("../../assets/images/nike4.webp")}`,
        title: "Nike",
        details: "Nike Air Max Terrascape",
        rating: 4,
        price: 11895,
        gender: "women",
    },
    {
        _id: uuid(),
        img: `${require("../../assets/images/puma6.webp")}`,
        title: "Puma",
        details: "X-Ray 2 Square",
        rating: 2,
        price: 4999,
        gender: "kids",
    },
    {
        _id: uuid(),
        img: `${require("../../assets/images/puma7.webp")}`,
        title: "Puma",
        details: "X-Ray 2 Square",
        rating: 5,
        price: 4999,
        gender: "kids",
    },
    {
        _id: uuid(),
        img: `${require("../../assets/images/adidas1.webp")}`,
        title: "Adidas",
        details: "Adifloss M",
        rating: 5,
        price: 3999,
        gender: "men",
    },
    {
        _id: uuid(),
        img: `${require("../../assets/images/vans4.webp")}`,
        title: "Vans",
        details: "Vans Eco Theory Sk8-Hi",
        rating: 3,
        price: 9695,
        gender: "men",
    },
    {
        _id: uuid(),
        img: `${require("../../assets/images/vans5.webp")}`,
        title: "Vans",
        details: "Vans Retro Floral Era",
        rating: 4,
        price: 9695,
        gender: "women",
    },
    {
        _id: uuid(),
        img: `${require("../../assets/images/vans6.webp")}`,
        title: "Vans",
        details: "Vans Sentry Old Skool WC",
        rating: 2,
        price: 9695,
        gender: "women",
    },
    {
        _id: uuid(),
        img: `${require("../../assets/images/vans7.webp")}`,
        title: "Vans",
        details: "Vans Sentry Old Skool WC",
        rating: 3,
        price: 9695,
        gender: "kids",
    },
    {
        _id: uuid(),
        img: `${require("../../assets/images/puma1.webp")}`,
        title: "Puma",
        details: "X-Ray Speed",
        rating: 4,
        price: 6999,
        gender: "men",
    },
    {
        _id: uuid(),
        img: `${require("../../assets/images/adidas2.webp")}`,
        title: "Adidas",
        details: "YZY 700 MNVN",
        rating: 3,
        price: 3999,
        gender: "men",
    },
    {
        _id: uuid(),
        img: `${require("../../assets/images/nike1.webp")}`,
        title: "Nike",
        details: "Nike Air Force 1 '07",
        rating: 5,
        price: 7495,
        gender: "men",
    },

    {
        _id: uuid(),
        img: `${require("../../assets/images/nike5.webp")}`,
        title: "Nike",
        details: "Nike Flex Runner 2",
        rating: 3,
        price: 3495,
        gender: "kids",
    },
    {
        _id: uuid(),
        img: `${require("../../assets/images/nike6.webp")}`,
        title: "Nike",
        details: "Nike Flex Runner 2",
        rating: 2,
        price: 3495,
        gender: "kids",
    },
    {
        _id: uuid(),
        img: `${require("../../assets/images/nike7.webp")}`,
        title: "Nike",
        details: "Nike Flex Runner 2",
        rating: 3,
        price: 3495,
        gender: "kids",
    },
    {
        _id: uuid(),
        img: `${require("../../assets/images/puma2.webp")}`,
        title: "Puma",
        details: "Scorch Runner",
        rating: 1,
        price: 4699,
        gender: "men",
    },
    {
        _id: uuid(),
        img: `${require("../../assets/images/puma3.webp")}`,
        title: "Puma",
        details: "Smash Platform V2",
        rating: 3,
        price: 5499,
        gender: "women",
    },
    {
        _id: uuid(),
        img: `${require("../../assets/images/puma4.webp")}`,
        title: "Puma",
        details: "Tori SD",
        rating: 3,
        price: 5499,
        gender: "women",
    },
    {
        _id: uuid(),
        img: `${require("../../assets/images/puma5.webp")}`,
        title: "Puma",
        details: "Jada Galentines",
        rating: 5,
        price: 5499,
        gender: "women",
    },
];
